import { useState } from 'react'

import { AverageCheckFilterControls } from 'app/filters/reports/averageCheck'
import { ReportSection, ResetLink } from 'app/common/templates-next/report-template'
import { filterActions } from 'app/filters/reports/averageCheck/filterStore'
import { useReportPerform } from 'app/dataProviders/reports/hooks'
import { canMailingOnly, MailingBox } from 'app/common/ui-next/_filter-compilations/mailing'
import { ReportType } from 'app/dataTypes/reports'

import styles from './Filters.module.scss'

const isMailingOnly = (formData: FormData) => !!canMailingOnly(formData)

type Props = {
  email?: string | null
  profileLink: string
  onReportId: (reportId: string | null) => void
}

export const Filters = ({ email, profileLink, onReportId }: Props) => {
  const [pending, setPending] = useState(false)

  const { perform } = useReportPerform({
    onReportId,
    isMailingOnly,
  })

  const performWithAdditionalData = async (formData: FormData) => {
    setPending(true)
    await perform({ formData, reportType: ReportType.AverageCheck })
    setPending(false)
  }

  return (
    <ReportSection
      header="Фильтры"
      headerBar={
        <ResetLink onClick={filterActions.resetToDefaults}>{'Сбросить все фильтры'}</ResetLink>
      }
      resetStickyShift={false}
    >
      <AverageCheckFilterControls
        className={styles.filters}
        email={email}
        profileLink={profileLink}
        onApply={performWithAdditionalData}
        pending={pending}
      />
    </ReportSection>
  )
}
